import React from 'react';
import styled from 'styled-components';
import {ArrowRight} from '@styled-icons/bootstrap/ArrowRight';
import * as AppActions from '../../AppActions';
import {getDateLabel} from '../../Utils/DateUtil';
import {getDisableLabels} from '../../Utils/ProductUtil';

export default function ProductItem(props) {
  const {product, onClick} = props;
  const disableLabels = getDisableLabels(product);

  return (
    <Wrapper>
      <div className="date">
        {getDateLabel(new Date(product.start_date))}{' '}
        {product?.end_date && ' ~ ' + getDateLabel(new Date(product?.end_date))}
      </div>
      <div className="title">{product.name}</div>
      <div className="info">
        <div>
          <label>時數</label>
          <div>
            <div>{product.hours || 0} 小時</div>
          </div>
        </div>
        <div>
          <label>時數類別</label>
          <ul>
            {product.hours_catagory?.option_1 && (
              <li style={{backgroundColor: '#043186', color: 'white'}}>獎</li>
            )}
            {product.hours_catagory?.option_2 && (
              <li style={{backgroundColor: '#1B61A7', color: 'white'}}>職</li>
            )}
            {product.hours_catagory?.option_3 && (
              <li style={{backgroundColor: '#6999C7', color: 'white'}}>訴</li>
            )}
            {product.hours_catagory?.option_4 && (
              <li style={{backgroundColor: '#B8D0E7', color: 'white'}}>商</li>
            )}
          </ul>
        </div>
      </div>

      <div
        className="actions"
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}>
        <button onClick={onClick}>
          <ArrowRight size={18} style={{paddingBottom: 2}} />
          查看詳情
        </button>
        {disableLabels.length > 0 && (
          <div style={{color: '#aaa', textAlign: 'right', marginLeft: 6}}>
            ({disableLabels[0]})
          </div>
        )}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: white;
  transition: all 200ms;
  &:hover {
    box-shadow: 0px 8px 12px rgba(0,0,0,0.3);
  }

  .date {
    color: #043186;
  }

  .title {
    margin-top: 12px;
    font-weight: bold;
    min-height: 100px;
  }

  .info {
    margin: 12px 0;
    border-top: 1px solid #ddd;
    padding: 12px 0;
    border-bottom: 1px solid #ddd;

    & > * {
      display: flex;
      &:not(:last-child) {
        margin-bottom: 12px;
      }

      & > label {
        width: 80px;
        color: #043186;
      }

      & > ul {
        display: flex;
        gap: 6px;
        list-style-type: none;
        padding: 0;
        margin: 0;

        & > li {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 26px;
          height: 26px;
          border-radius: 13px;
        }
      }
    }
  }

  .actions {
    display: flex;
    justify-content; flex-end;
    button {
      padding: 0;
      border: 0;
      display: flex;
      align-items: center;
      gap: 8px;
      background-color: transparent;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        color: #043186;
        font-weight: bold;
      }
    }
  }
`;
